/**
 * Modelo de classe para representar a estrutura do relatorio
 */
export class Relatorio {
  atendimento: number;
  autorizacao: number;
  codigoPrestador: number;
  nomePrestador: string;
  contrato: number;
  matricula: number;
  codigoBeneficiario: number;
  nomeBeneficiario: string;
  dataInicioAtedimento: Date;
  dataTerminoAtendimento: Date;
  totalServico = 0;
  totalMaterial = 0;
  totalMedicamentos = 0;
  totalTaxa = 0;
  totalDiaria = 0;
  totalGeral = 0;
  percentual: number;
}
